import React, { useEffect, useMemo, useState } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'
import { getBlueprints } from '../../infrastructure/actions'
interface Props {
  includeNoneOption?: boolean
}

export default function VolumeBackendPicklist({
  name = 'volumeBackend',
  label = 'Volume Backend',
  compact = false,
  includeNoneOption = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const [backendNames, setBackendNames] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getDriverDetails = async () => {
      try {
        const blueprints = await getBlueprints()
        setBackendNames(Object.keys(blueprints[0]?.storageBackends ?? {}) ?? [])
      } catch (error) {
        // Handle error gracefully - just show empty list
        setBackendNames([])
      } finally {
        setLoading(false)
      }
    }

    getDriverDetails()
  }, [])

  const volumeBackendOptions = useMemo(() => {
    if (backendNames.length > 0) {
      const filteredOptions = backendNames.map((name) => ({
        label: name,
        value: name,
      }))

      return includeNoneOption
        ? [{ label: 'None', value: '' }, ...filteredOptions]
        : filteredOptions
    }
    return []
  }, [backendNames, includeNoneOption])

  return (
    <AsyncDropdown
      compact={compact}
      name={name}
      loading={loading}
      label={label}
      items={volumeBackendOptions}
      {...rest}
    />
  )
}
